import { TEMPLATE_APP, TEMPLATE_APP_CHART_OF_ACCOUNTS, TEMPLATE_APP_SOURCE_DATA_TABLES, TEMPLATE_APP_PERMISSION, TEMPLATE_APP_TEAM, TEMPLATE_APP_OUTPUT, QSC_APP_SPECIFIC_FIELDS, RAC_APP_SPECIFIC_FIELDS, AI_APP_SPECIFIC_FIELDS } from "../Constants";
import { FRISCO_TABLE_STATUS, PROCESS_KEYS } from "src/Ateam-BI/Frisco/Constants";
import { PROCESS_KEYS as LOGICO_PROCESS_KEYS } from "src/Ateam-BI/Logico/Constants";

import { API, graphqlOperation } from "aws-amplify";
import * as XLSX from "xlsx";
import { callPlusGraphQLDirect } from "src/utilities/AWSServices";
import { configurePlusAppsync, configureGenericAppSync } from "src/context/AuthContextUtility";


const clean = (value) => {
  return value.replaceAll("'", "''")
}

function stringify(obj_from_json) {
  if (obj_from_json == null) {
    return null;
  }
  if (typeof obj_from_json !== "object" || Array.isArray(obj_from_json)) {
    // not an object, stringify using native function
    return JSON.stringify(obj_from_json);
  }
  // Implements recursive object serialization according to JSON spec
  // but without quotes around the keys.
  let props = Object
    .keys(obj_from_json)
    .map(key => `${key}:${stringify(obj_from_json[key])}`)
    .join(",");
  return `{${props}}`;
}

const cleanAll = (value) => {
  let cleaned = null
  if (value == null) {
  } else if (value instanceof Array) {
    cleaned = []
    value.forEach((item) => {
      if (typeof (item) == 'string') {
        cleaned.push(JSON.stringify(clean(item)))
      } else {
        cleaned.push(stringify(item))
      }
    })
    cleaned = `[${cleaned}]`
  } else {
    cleaned = stringify(value)
  }
  return cleaned
}

export const getQueryInput = (data, keysToIgnore = [TEMPLATE_APP.CREATE_TIME_STAMP, TEMPLATE_APP.LAST_UPDATED_TIME_STAMP, TEMPLATE_APP.DEV_ALERT_MESSAGES]) => {
  let val = []
  Object.keys(data).forEach(function (key) {
    if (keysToIgnore.includes(key)) {
      return;
    }
    if (data[key] !== null && data[key] !== undefined) {
      let value = data[key]
      if (typeof (value) == 'string') {
        value = clean(value)
        val.push(`${key}:${JSON.stringify(value)}`)
      } else if (value instanceof Array) {
        value = cleanAll(value)
        val.push(`${key}:${value}`)
      } else {
        value = cleanAll(value)
        val.push(`${key}:${value}`)
      }
    } else {
      val.push(`${key}:null`)
    }
  })
  return val.join(",")
}

const getMetadataInput = (data) => {
  let val = []
  let keysToIgnore = []
  Object.keys(data).forEach(function (key) {
    if (keysToIgnore.includes(key)) {
      return;
    }
    if (data[key]) {
      let value = data[key]
      if (typeof (value) == 'string') {
        value = clean(value)
        val.push(`${key}:${JSON.stringify(value)}`)
      } else if (value instanceof Array) {
        value = cleanAll(value)
        val.push(`${key}:${value}`)
      } else {
        value = cleanAll(value)
        val.push(`${key}:${value}`)
      }
    } else {
      val.push(`${key}:null`)
    }
  })
  return val.join(",")
}

export const updateApp = (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
      updateAppV2(
        input: {
          ${getQueryInput(data)}}) {
            ${TEMPLATE_APP.APP_DESCRIPTION}
            ${TEMPLATE_APP.APP_NAME}
            ${TEMPLATE_APP.APP_ID}
            ${TEMPLATE_APP.TEMPLATE_ID}
            ${TEMPLATE_APP.URL}
            ${TEMPLATE_APP.PROCESS_OWNER}
            ${TEMPLATE_APP.GRC_CONTROL_OWNER}
            ${TEMPLATE_APP.TDD}
            ${TEMPLATE_APP.STATUS}
            ${TEMPLATE_APP.REGION}
            ${TEMPLATE_APP.CADENCE}
            ${TEMPLATE_APP.PROCESS_MJE_COUNT}
            ${TEMPLATE_APP.FLASH_INFO_DESCRIPTION}
            ${TEMPLATE_APP.DEV_ALERT_MESSAGES}
            ${TEMPLATE_APP.ANNUAL_MER_SAVINGS}
            ${TEMPLATE_APP.PDD}
            ${TEMPLATE_APP.LEDGER_INFO}
            ${TEMPLATE_APP.LAUNCH_MCM}
            ${TEMPLATE_APP.LAUNCH_QQ_YY}
            ${TEMPLATE_APP.INPUT_SOURCE_TYPE}
            ${TEMPLATE_APP.AUTOMATION_TOOLS}
            ${TEMPLATE_APP.ARD}
            ${TEMPLATE_APP.DATASOURCE}
            ${TEMPLATE_APP.ORGANIZATION}
            ${TEMPLATE_APP.FINANCIAL_RELEVANCE}
            ${TEMPLATE_APP.FINANCIAL_YEAR_IMPACT}
            ${TEMPLATE_APP.VP}
            ${TEMPLATE_APP.CREATE_TIME_STAMP}
            ${TEMPLATE_APP.CREATED_BY}
            ${TEMPLATE_APP.LAST_UPDATED_TIME_STAMP}
            ${TEMPLATE_APP.LAST_UPDATED_BY}
            ${TEMPLATE_APP.SIM_TICKET_URL}
            ${TEMPLATE_APP.SIM_TICKET_LABEL}
            ${TEMPLATE_APP.CHART_OF_ACCOUNT}{
              ${TEMPLATE_APP_CHART_OF_ACCOUNTS.CHART_OF_ACCOUNTS_PK}
              ${TEMPLATE_APP_CHART_OF_ACCOUNTS.FPA_DIM_ACCOUNTS}
            }
            ${TEMPLATE_APP.SOURCE_DATA_TABLES}{
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.DESCRIPTION}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.SCHEMA}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.SOURCE_TABLE_PK}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.TABLE}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.DATABASE}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.UPSTREAM_SOURCE}
            }
            ${TEMPLATE_APP.USE_CASE}
            ${TEMPLATE_APP.PERMISSION}{
              ${TEMPLATE_APP_PERMISSION.LINK}
              ${TEMPLATE_APP_PERMISSION.NAME}
              ${TEMPLATE_APP_PERMISSION.APP_PERMISSION_PK}
            }
            ${TEMPLATE_APP.DEVELOPER_TEAM}{
              ${TEMPLATE_APP_TEAM.TEAM}
              ${TEMPLATE_APP_TEAM.EMAIL}
            }
            ${TEMPLATE_APP.OUTPUT}{
              ${TEMPLATE_APP_OUTPUT.TYPE}
              ${TEMPLATE_APP_OUTPUT.VALUE}
              ${TEMPLATE_APP_OUTPUT.LABEL}
              ${TEMPLATE_APP_OUTPUT.AWS_ACCOUNT}
              ${TEMPLATE_APP_OUTPUT.APP_OUTPUT_PK}
            }
            ${TEMPLATE_APP.ACCOUNTING_TEAM} {
              ${TEMPLATE_APP_TEAM.TEAM}
              ${TEMPLATE_APP_TEAM.EMAIL}
            }
      }
    }
    `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const addApp = (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
      addAppV2(
        input: {
          ${getQueryInput(data)}}) {
            ${TEMPLATE_APP.APP_DESCRIPTION}
            ${TEMPLATE_APP.APP_NAME}
            ${TEMPLATE_APP.APP_ID}
            ${TEMPLATE_APP.TEMPLATE_ID}
            ${TEMPLATE_APP.URL}
            ${TEMPLATE_APP.PROCESS_OWNER}
            ${TEMPLATE_APP.TDD}
            ${TEMPLATE_APP.STATUS}
            ${TEMPLATE_APP.REGION}
            ${TEMPLATE_APP.CADENCE}
            ${TEMPLATE_APP.PROCESS_MJE_COUNT}
            ${TEMPLATE_APP.ANNUAL_MER_SAVINGS}
            ${TEMPLATE_APP.PDD}
            ${TEMPLATE_APP.LEDGER_INFO}
            ${TEMPLATE_APP.LAUNCH_MCM}
            ${TEMPLATE_APP.LAUNCH_QQ_YY}
            ${TEMPLATE_APP.INPUT_SOURCE_TYPE}
            ${TEMPLATE_APP.AUTOMATION_TOOLS}
            ${TEMPLATE_APP.ARD}
            ${TEMPLATE_APP.DATASOURCE}
            ${TEMPLATE_APP.ORGANIZATION}
            ${TEMPLATE_APP.FINANCIAL_RELEVANCE}
            ${TEMPLATE_APP.FINANCIAL_YEAR_IMPACT}
            ${TEMPLATE_APP.VP}
            ${TEMPLATE_APP.CREATE_TIME_STAMP}
            ${TEMPLATE_APP.CREATED_BY}
            ${TEMPLATE_APP.LAST_UPDATED_TIME_STAMP}
            ${TEMPLATE_APP.LAST_UPDATED_BY}
            ${TEMPLATE_APP.SIM_TICKET_URL}
            ${TEMPLATE_APP.CHART_OF_ACCOUNT}{
              ${TEMPLATE_APP_CHART_OF_ACCOUNTS.CHART_OF_ACCOUNTS_PK}
              ${TEMPLATE_APP_CHART_OF_ACCOUNTS.FPA_DIM_ACCOUNTS}
            }
            ${TEMPLATE_APP.SOURCE_DATA_TABLES}{
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.DESCRIPTION}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.SCHEMA}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.SOURCE_TABLE_PK}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.TABLE}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.UPSTREAM_SOURCE}
            }
            ${TEMPLATE_APP.USE_CASE}
            ${TEMPLATE_APP.PERMISSION}{
              ${TEMPLATE_APP_PERMISSION.LINK}
              ${TEMPLATE_APP_PERMISSION.NAME}
              ${TEMPLATE_APP_PERMISSION.APP_PERMISSION_PK}
            }
            ${TEMPLATE_APP.DEVELOPER_TEAM}{
              ${TEMPLATE_APP_TEAM.TEAM}
              ${TEMPLATE_APP_TEAM.EMAIL}
            }
            ${TEMPLATE_APP.OUTPUT}{
              ${TEMPLATE_APP_OUTPUT.TYPE}
              ${TEMPLATE_APP_OUTPUT.VALUE}
              ${TEMPLATE_APP_OUTPUT.LABEL}
              ${TEMPLATE_APP_OUTPUT.AWS_ACCOUNT}
              ${TEMPLATE_APP_OUTPUT.APP_OUTPUT_PK}
            }
            ${TEMPLATE_APP.ACCOUNTING_TEAM} {
              ${TEMPLATE_APP_TEAM.TEAM}
              ${TEMPLATE_APP_TEAM.EMAIL}
            }
      }
    }
    `

  //console.log(qry)
  executeQuery(qry, onSuccess, onFailure)

}

export const getQSDashboardEmbedLinksSync = async (aws_account, dashboard_region, dashboard_id) => {
  let qry = `query MyQuery {
  getQSDashboardEmbedLinks(
    input: {dashboard_region: "${dashboard_region}", dashboard_id: "${dashboard_id}", aws_account: "${aws_account}" }
  )
}`
  let response = await callPlusGraphQLDirect(qry);
  let getQSDashboardEmbedLinksResponse = response.data.getQSDashboardEmbedLinks;
  return JSON.parse(getQSDashboardEmbedLinksResponse)
}

export const getAppsV2 = (id, onSuccess, onFailure) => {
  var qry = `query MyQuery {
    getAppsV2(ids: ["${id}"]) {
        ${TEMPLATE_APP.APP_DESCRIPTION}
          ${TEMPLATE_APP.APP_NAME}
          ${TEMPLATE_APP.APP_ID}
      }
    }  
`;

  //console.log(qry)
  executeQuery(qry, onSuccess, onFailure)

}

/**
 * Fetch the minimal App_Record(s) a card needs to render, via the
 * Cognito-authed Plus AppSync `getAppsV2` query (the same source of truth the
 * Marketplace grid uses).
 *
 * Selects exactly the fields `AppCard` consumes — name/description/status,
 * the optional `use_case` chips, click-through `url`, the AI-badge
 * `template_id`, and the enrichment stats (`rating_avg`, `rating_count`,
 * `view_count`) — so a "smart" card container can self-fetch without the
 * caller having to know where the data comes from.
 *
 * Accepts EITHER a single id or an array of ids:
 *  - single id  → resolves to the single App_Record, or `null` on a miss.
 *  - array of ids → resolves to an array of App_Records (only the ids that
 *    matched; order follows the `getAppsV2` response). An empty/whitespace-only
 *    list resolves to `[]` without a network call.
 *
 * Batching is important for correctness, not just efficiency: this function
 * mutates GLOBAL AppSync config (`configurePlusAppsync()` then, in `finally`,
 * `configureGenericAppSync()`). Calling it many times concurrently (e.g.
 * `Promise.all(ids.map(getAppCardData))`) would let one call's `finally` reset
 * the endpoint while another call's `API.graphql()` is still in flight against
 * the Plus endpoint — a race on shared global state. Passing the whole id list
 * here performs a single configure/query/reset cycle and avoids that race
 * (and removes N-1 redundant configure round-trips).
 *
 * Promise-based (unlike the callback-style `getAppsV2`) so a container can
 * `await` it directly.
 *
 * @param {string|number|Array<string|number>} appIdOrIds - One id or many.
 * @returns {Promise<Object|null|Array<Object>>} A single App_Record / `null`
 *   for a single id, or an array of App_Records for an array of ids.
 */
export const getAppCardData = async (appIdOrIds) => {
  const isBatch = Array.isArray(appIdOrIds);
  const ids = (isBatch ? appIdOrIds : [appIdOrIds]).filter((id) => id != null && `${id}`.trim() !== '');

  // Nothing to fetch — return the shape matching the caller's input without
  // touching the (global) AppSync config.
  if (ids.length === 0) {
    return isBatch ? [] : null;
  }

  const idsStr = ids.map((id) => `"${id}"`).join(', ');
  const qry = `query MyQuery {
    getAppsV2(ids: [${idsStr}]) {
      ${TEMPLATE_APP.APP_ID}
      ${TEMPLATE_APP.APP_NAME}
      ${TEMPLATE_APP.APP_DESCRIPTION}
      ${TEMPLATE_APP.TEMPLATE_ID}
      ${TEMPLATE_APP.STATUS}
      ${TEMPLATE_APP.URL}
      ${TEMPLATE_APP.USE_CASE}
      ${TEMPLATE_APP.RATING_AVG}
      ${TEMPLATE_APP.RATING_COUNT}
      ${TEMPLATE_APP.VIEW_COUNT}
    }
  }`;

  try {
    await configurePlusAppsync();
    const response = await API.graphql(graphqlOperation(qry));
    const apps = response?.data?.getAppsV2;
    const list = Array.isArray(apps) ? apps : [];
    if (isBatch) {
      return list;
    }
    return list.length > 0 ? list[0] : null;
  } finally {
    await configureGenericAppSync();
  }
};

export const getAppPromise = async (id) => {
  var mQry = `query MyQuery {
    getAppsV2(ids: ["${id}"]) {
        ${TEMPLATE_APP.APP_DESCRIPTION}
          ${TEMPLATE_APP.APP_NAME}
          ${TEMPLATE_APP.APP_ID}
          ${TEMPLATE_APP.TEMPLATE_ID}
          ${TEMPLATE_APP.FLASH_INFO_DESCRIPTION}
          ${TEMPLATE_APP.DEV_ALERT_MESSAGES}
          ${TEMPLATE_APP.URL}
          ${TEMPLATE_APP.PROCESS_OWNER}
          ${TEMPLATE_APP.TDD}
          ${TEMPLATE_APP.STATUS}
          ${TEMPLATE_APP.REGION}
          ${TEMPLATE_APP.CADENCE}
          ${TEMPLATE_APP.PROCESS_MJE_COUNT}
          ${TEMPLATE_APP.ANNUAL_MER_SAVINGS}
          ${TEMPLATE_APP.PDD}
          ${TEMPLATE_APP.LEDGER_INFO}
          ${TEMPLATE_APP.LAUNCH_MCM}
          ${TEMPLATE_APP.LAUNCH_QQ_YY}
          ${TEMPLATE_APP.INPUT_SOURCE_TYPE}
          ${TEMPLATE_APP.AUTOMATION_TOOLS}
          ${TEMPLATE_APP.ARD}
          ${TEMPLATE_APP.DATASOURCE}
          ${TEMPLATE_APP.ORGANIZATION}
          ${TEMPLATE_APP.VP}
          ${TEMPLATE_APP.CREATE_TIME_STAMP}
          ${TEMPLATE_APP.CREATED_BY}
          ${TEMPLATE_APP.LAST_UPDATED_TIME_STAMP}
          ${TEMPLATE_APP.LAST_UPDATED_BY}
          ${TEMPLATE_APP.SIM_TICKET_URL}
          ${TEMPLATE_APP.SIM_TICKET_LABEL}
          ${TEMPLATE_APP.RATING_AVG}
          ${TEMPLATE_APP.RATING_COUNT}
          ${TEMPLATE_APP.VIEW_COUNT}
          ${TEMPLATE_APP.USE_CASE}
          ${TEMPLATE_APP.CHART_OF_ACCOUNT}{
            ${TEMPLATE_APP_CHART_OF_ACCOUNTS.CHART_OF_ACCOUNTS_PK}
            ${TEMPLATE_APP_CHART_OF_ACCOUNTS.FPA_DIM_ACCOUNTS}
          }
          ${TEMPLATE_APP.SOURCE_DATA_TABLES}{
            ${TEMPLATE_APP_SOURCE_DATA_TABLES.DESCRIPTION}
            ${TEMPLATE_APP_SOURCE_DATA_TABLES.SCHEMA}
            ${TEMPLATE_APP_SOURCE_DATA_TABLES.SOURCE_TABLE_PK}
            ${TEMPLATE_APP_SOURCE_DATA_TABLES.TABLE}
            ${TEMPLATE_APP_SOURCE_DATA_TABLES.DATABASE}
            ${TEMPLATE_APP_SOURCE_DATA_TABLES.UPSTREAM_SOURCE}
          }
          ${TEMPLATE_APP.PERMISSION}{
            ${TEMPLATE_APP_PERMISSION.LINK}
            ${TEMPLATE_APP_PERMISSION.NAME}
            ${TEMPLATE_APP_PERMISSION.APP_PERMISSION_PK}
          }
          ${TEMPLATE_APP.DEVELOPER_TEAM}{
            ${TEMPLATE_APP_TEAM.TEAM}
            ${TEMPLATE_APP_TEAM.EMAIL}
          }
          ${TEMPLATE_APP.OUTPUT}{
            ${TEMPLATE_APP_OUTPUT.TYPE}
            ${TEMPLATE_APP_OUTPUT.VALUE}
            ${TEMPLATE_APP_OUTPUT.LABEL}
            ${TEMPLATE_APP_OUTPUT.AWS_ACCOUNT}
            ${TEMPLATE_APP_OUTPUT.APP_OUTPUT_PK}
          }
          ${TEMPLATE_APP.ACCOUNTING_TEAM} {
            ${TEMPLATE_APP_TEAM.TEAM}
            ${TEMPLATE_APP_TEAM.EMAIL}
          }
      }
    }  
`;
  // console.log(mQry)
  return callPlusGraphQLDirect(mQry)
};

export const getAllAppsForConsolidatedSheet = async () => {
  let mQry = `
  query MyQuery {
    getAppsV2 {
      ${TEMPLATE_APP.APP_ID}
      ${TEMPLATE_APP.APP_NAME}
      ${TEMPLATE_APP.APP_DESCRIPTION}
        ${TEMPLATE_APP.TEMPLATE_ID}
        ${TEMPLATE_APP.URL}
        ${TEMPLATE_APP.PROCESS_OWNER}
        ${TEMPLATE_APP.GRC_CONTROL_OWNER}
        ${TEMPLATE_APP.FLASH_INFO_DESCRIPTION}
        ${TEMPLATE_APP.DEV_ALERT_MESSAGES}
        ${TEMPLATE_APP.TDD}
        ${TEMPLATE_APP.STATUS}
        ${TEMPLATE_APP.REGION}
        ${TEMPLATE_APP.CADENCE}
        ${TEMPLATE_APP.PROCESS_MJE_COUNT}
        ${TEMPLATE_APP.ANNUAL_MER_SAVINGS}
        ${TEMPLATE_APP.PDD}
        ${TEMPLATE_APP.LEDGER_INFO}
        ${TEMPLATE_APP.LAUNCH_MCM}
        ${TEMPLATE_APP.LAUNCH_QQ_YY}
        ${TEMPLATE_APP.INPUT_SOURCE_TYPE}
        ${TEMPLATE_APP.AUTOMATION_TOOLS}
        ${TEMPLATE_APP.ARD}
        ${TEMPLATE_APP.DATASOURCE}
        ${TEMPLATE_APP.ORGANIZATION}
        ${TEMPLATE_APP.FINANCIAL_RELEVANCE}
        ${TEMPLATE_APP.FINANCIAL_YEAR_IMPACT}
        ${TEMPLATE_APP.GRC_CONTROL_ID}
        ${TEMPLATE_APP.VP}
        ${TEMPLATE_APP.CREATE_TIME_STAMP}
        ${TEMPLATE_APP.CREATED_BY}
        ${TEMPLATE_APP.LAST_UPDATED_TIME_STAMP}
        ${TEMPLATE_APP.LAST_UPDATED_BY}
        ${TEMPLATE_APP.SIM_TICKET_URL}
        ${TEMPLATE_APP.SIM_TICKET_LABEL}
        ${TEMPLATE_APP.RATING_AVG}
        ${TEMPLATE_APP.RATING_COUNT}
        ${TEMPLATE_APP.VIEW_COUNT}
        ${TEMPLATE_APP.CHART_OF_ACCOUNT}{
          ${TEMPLATE_APP_CHART_OF_ACCOUNTS.CHART_OF_ACCOUNTS_PK}
          ${TEMPLATE_APP_CHART_OF_ACCOUNTS.FPA_DIM_ACCOUNTS}
        }
        ${TEMPLATE_APP.SOURCE_DATA_TABLES}{
          ${TEMPLATE_APP_SOURCE_DATA_TABLES.DESCRIPTION}
          ${TEMPLATE_APP_SOURCE_DATA_TABLES.SCHEMA}
          ${TEMPLATE_APP_SOURCE_DATA_TABLES.SOURCE_TABLE_PK}
          ${TEMPLATE_APP_SOURCE_DATA_TABLES.TABLE}
          ${TEMPLATE_APP_SOURCE_DATA_TABLES.DATABASE}
          ${TEMPLATE_APP_SOURCE_DATA_TABLES.UPSTREAM_SOURCE}
        }
        ${TEMPLATE_APP.USE_CASE}
        ${TEMPLATE_APP.PERMISSION}{
          ${TEMPLATE_APP_PERMISSION.LINK}
          ${TEMPLATE_APP_PERMISSION.NAME}
          ${TEMPLATE_APP_PERMISSION.APP_PERMISSION_PK}
        }
        ${TEMPLATE_APP.DEVELOPER_TEAM}{
          ${TEMPLATE_APP_TEAM.TEAM}
          ${TEMPLATE_APP_TEAM.EMAIL}
        }
        ${TEMPLATE_APP.OUTPUT}{
          ${TEMPLATE_APP_OUTPUT.TYPE}
          ${TEMPLATE_APP_OUTPUT.VALUE}
          ${TEMPLATE_APP_OUTPUT.LABEL}
          ${TEMPLATE_APP_OUTPUT.AWS_ACCOUNT}
          ${TEMPLATE_APP_OUTPUT.APP_OUTPUT_PK}
        }
        ${TEMPLATE_APP.ACCOUNTING_TEAM} {
          ${TEMPLATE_APP_TEAM.TEAM}
          ${TEMPLATE_APP_TEAM.EMAIL}
        }
    }
  }  
      `;

  let response = await callPlusGraphQLDirect(mQry);
  let qResult = response.data.getAppsV2;
  return qResult

}

export const deleteAppWithApproval = (app_id, approval_id, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    deleteAppRequestV2(input: {app_id: "${app_id}", approval_id:"${approval_id}"}) {
        message
      }
    }
    `
  executeQuery(qry, onSuccess, onFailure)

}

export const setMetadataValues = (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    setAppMetadataFieldValuesV2(
      input: [{
        ${getMetadataInput(data)}}]) {
          message
    }
  }
  `
  executeQuery(qry, onSuccess, onFailure)

}

export const getApprovalsForApp = (app_id, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getApprovalForAppV2(app_id: "${app_id}") {
      app_id
      approval_id
      next_action
    }
  }`
  executeQuery(qry, onSuccess, onFailure)
}

export const createProcess = (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    createProcessV2(input: {${getQueryInput(data, [])}}
    ) {
      ${PROCESS_KEYS.app_id}
      ${PROCESS_KEYS.label}
      ${PROCESS_KEYS.description}
      ${PROCESS_KEYS.glue_job_name}
      ${PROCESS_KEYS.step_function_name}
      ${PROCESS_KEYS.environment}
      ${PROCESS_KEYS.action}
      ${PROCESS_KEYS.team}
      ${PROCESS_KEYS.business} 
      ${PROCESS_KEYS.dataset_name}
      ${PROCESS_KEYS.created_by}
      ${PROCESS_KEYS.last_updated_by}
      ${PROCESS_KEYS.created_time_stamp}
      ${PROCESS_KEYS.last_updated_time_stamp}
      ${PROCESS_KEYS.approval_required}
      ${PROCESS_KEYS.multipart_allowed}
      ${PROCESS_KEYS.redshift_table_name}
      ${PROCESS_KEYS.status}
      ${PROCESS_KEYS.sox_approved}
      ${PROCESS_KEYS.sox_evidence}
      ${PROCESS_KEYS.critical_data}
      ${PROCESS_KEYS.approvers}{
        ${PROCESS_KEYS.APPROVER_KEYS.alias}
        ${PROCESS_KEYS.APPROVER_KEYS.type}
        ${PROCESS_KEYS.APPROVER_KEYS.column_index}
      }
      ${PROCESS_KEYS.uploaders}{
        ${PROCESS_KEYS.UPLOADER_KEYS.alias}
        ${PROCESS_KEYS.UPLOADER_KEYS.type}
      }
      ${PROCESS_KEYS.file_types}
      ${PROCESS_KEYS.label}
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.process_name}
      ${PROCESS_KEYS.schema}{
        ${PROCESS_KEYS.SCHEMA_KEYS.column_name}
        ${PROCESS_KEYS.SCHEMA_KEYS.data_type}
        ${PROCESS_KEYS.SCHEMA_KEYS.mandatory}
        ${PROCESS_KEYS.SCHEMA_KEYS.delsert_key}
        ${PROCESS_KEYS.SCHEMA_KEYS.non_empty_column}
        ${PROCESS_KEYS.SCHEMA_KEYS.scale}
        ${PROCESS_KEYS.SCHEMA_KEYS.precision}
        ${PROCESS_KEYS.SCHEMA_KEYS.length}
        ${PROCESS_KEYS.SCHEMA_KEYS.last_updated_time_stamp}
        ${PROCESS_KEYS.SCHEMA_KEYS.column_index}
        ${PROCESS_KEYS.SCHEMA_KEYS.prev_column_name}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_operator}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_value}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_type}
      }
      ${PROCESS_KEYS.custom_attributes}{
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
      }
    }
  }
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)

}

export const updateProcess = (data, onSuccess, onFailure) => {
  const arr = [PROCESS_KEYS.created_by, PROCESS_KEYS.created_time_stamp, PROCESS_KEYS.last_updated_time_stamp, PROCESS_KEYS.redshift_table_name]
  if (!data[PROCESS_KEYS.status] || data[PROCESS_KEYS.status] == FRISCO_TABLE_STATUS.CREATING_TABLE) {
    arr.push(PROCESS_KEYS.status)
  }
  let qry = `mutation MyMutation {
    updateProcessV2(input: {${getQueryInput(data, arr)}}
    ) {
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.app_id}
      ${PROCESS_KEYS.label}
      ${PROCESS_KEYS.description}
      ${PROCESS_KEYS.glue_job_name}
      ${PROCESS_KEYS.step_function_name}
      ${PROCESS_KEYS.environment}
      ${PROCESS_KEYS.action}
      ${PROCESS_KEYS.status}
      ${PROCESS_KEYS.team}
      ${PROCESS_KEYS.business}
      ${PROCESS_KEYS.dataset_name}
      ${PROCESS_KEYS.created_by}
      ${PROCESS_KEYS.last_updated_by}
      ${PROCESS_KEYS.created_time_stamp}
      ${PROCESS_KEYS.last_updated_time_stamp}
      ${PROCESS_KEYS.approval_required}
      ${PROCESS_KEYS.multipart_allowed}
      ${PROCESS_KEYS.redshift_table_name}
      ${PROCESS_KEYS.sox_approved}
      ${PROCESS_KEYS.sox_evidence}
      ${PROCESS_KEYS.critical_data}
      ${PROCESS_KEYS.approvers}{
        ${PROCESS_KEYS.APPROVER_KEYS.alias}
        ${PROCESS_KEYS.APPROVER_KEYS.type}
        ${PROCESS_KEYS.APPROVER_KEYS.column_index}
      }
      ${PROCESS_KEYS.uploaders}{
        ${PROCESS_KEYS.UPLOADER_KEYS.alias}
        ${PROCESS_KEYS.UPLOADER_KEYS.type}
      }
      ${PROCESS_KEYS.file_types}
      ${PROCESS_KEYS.label}
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.process_name}
      ${PROCESS_KEYS.schema}{
        ${PROCESS_KEYS.SCHEMA_KEYS.column_name}
        ${PROCESS_KEYS.SCHEMA_KEYS.data_type}
        ${PROCESS_KEYS.SCHEMA_KEYS.mandatory}
        ${PROCESS_KEYS.SCHEMA_KEYS.delsert_key}
        ${PROCESS_KEYS.SCHEMA_KEYS.non_empty_column}
        ${PROCESS_KEYS.SCHEMA_KEYS.scale}
        ${PROCESS_KEYS.SCHEMA_KEYS.precision}
        ${PROCESS_KEYS.SCHEMA_KEYS.length}
        ${PROCESS_KEYS.SCHEMA_KEYS.last_updated_time_stamp}
        ${PROCESS_KEYS.SCHEMA_KEYS.column_index}
        ${PROCESS_KEYS.SCHEMA_KEYS.prev_column_name}
        ${PROCESS_KEYS.SCHEMA_KEYS.prev_column_index}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_operator}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_value}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_type}
      }
      ${PROCESS_KEYS.custom_attributes}{
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
      }
      
    }
  }
  `
  // console.log(data, qry)
  executeQuery(qry, onSuccess, onFailure)

}

export const updateProcessLite = (data, onSuccess, onFailure) => {
  const arr = [PROCESS_KEYS.created_by, PROCESS_KEYS.created_time_stamp, PROCESS_KEYS.last_updated_time_stamp, PROCESS_KEYS.redshift_table_name]
  if (!data[PROCESS_KEYS.status] || data[PROCESS_KEYS.status] == FRISCO_TABLE_STATUS.CREATING_TABLE) {
    arr.push(PROCESS_KEYS.status)
  }
  let qry = `mutation MyMutation {
    updateProcessLiteV2(input: {${getQueryInput(data, arr)}}
    ) {
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.app_id}
      ${PROCESS_KEYS.label}
      ${PROCESS_KEYS.description}
      ${PROCESS_KEYS.glue_job_name}
      ${PROCESS_KEYS.step_function_name}
      ${PROCESS_KEYS.environment}
      ${PROCESS_KEYS.action}
      ${PROCESS_KEYS.status}
      ${PROCESS_KEYS.team}
      ${PROCESS_KEYS.business}
      ${PROCESS_KEYS.dataset_name}
      ${PROCESS_KEYS.created_by}
      ${PROCESS_KEYS.last_updated_by}
      ${PROCESS_KEYS.created_time_stamp}
      ${PROCESS_KEYS.last_updated_time_stamp}
      ${PROCESS_KEYS.approval_required}
      ${PROCESS_KEYS.multipart_allowed}
      ${PROCESS_KEYS.redshift_table_name}
      ${PROCESS_KEYS.sox_approved}
      ${PROCESS_KEYS.sox_evidence}
      ${PROCESS_KEYS.critical_data}
      ${PROCESS_KEYS.approvers}{
        ${PROCESS_KEYS.APPROVER_KEYS.alias}
        ${PROCESS_KEYS.APPROVER_KEYS.type}
        ${PROCESS_KEYS.APPROVER_KEYS.column_index}
      }
      ${PROCESS_KEYS.uploaders}{
        ${PROCESS_KEYS.UPLOADER_KEYS.alias}
        ${PROCESS_KEYS.UPLOADER_KEYS.type}
      }
      ${PROCESS_KEYS.file_types}
      ${PROCESS_KEYS.label}
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.process_name}
      ${PROCESS_KEYS.schema}{
        ${PROCESS_KEYS.SCHEMA_KEYS.column_name}
        ${PROCESS_KEYS.SCHEMA_KEYS.data_type}
        ${PROCESS_KEYS.SCHEMA_KEYS.mandatory}
        ${PROCESS_KEYS.SCHEMA_KEYS.delsert_key}
        ${PROCESS_KEYS.SCHEMA_KEYS.non_empty_column}
        ${PROCESS_KEYS.SCHEMA_KEYS.scale}
        ${PROCESS_KEYS.SCHEMA_KEYS.precision}
        ${PROCESS_KEYS.SCHEMA_KEYS.length}
        ${PROCESS_KEYS.SCHEMA_KEYS.last_updated_time_stamp}
        ${PROCESS_KEYS.SCHEMA_KEYS.column_index}
        ${PROCESS_KEYS.SCHEMA_KEYS.prev_column_name}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_operator}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_value}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_type}
      }
      ${PROCESS_KEYS.custom_attributes}{
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
      }
    }
  }
  `
  // console.log(data, qry)
  executeQuery(qry, onSuccess, onFailure)

}

export const createAuditLog = (pk, sk, comments, before, after, action, actor, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    createABCUIAuditLogging(input: {pk: "${pk}", sk: "${sk}", comments: "${comments}", before: ${JSON.stringify(before)}, 
    after: ${JSON.stringify(after)}, action: "${action}", actor: "${actor}",last_updated_time_stamp: "${Date.now()}"}) {
      action
      actor
      after
      before
      comments
      pk
      sk
    }
  }
  `
  //console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const getCurrentTime = () => {
  return Date.now();
}

export const getProcessForAppId = (appId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getProcessesForAppIDV2(app_id: "${appId}") {
      ${PROCESS_KEYS.app_id}
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.label}
      ${PROCESS_KEYS.created_by}
      ${PROCESS_KEYS.approvers} {
        ${PROCESS_KEYS.APPROVER_KEYS.alias}
        ${PROCESS_KEYS.APPROVER_KEYS.type}
      }
      ${PROCESS_KEYS.uploaders} {
        ${PROCESS_KEYS.UPLOADER_KEYS.alias}
        ${PROCESS_KEYS.UPLOADER_KEYS.type}
      }
  
    }
  }  
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getProcessForAppIdByGroup = (appId, groupId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getProcessesForAppIDV2(app_id: "${appId}", group_id: "${groupId}") {
      ${PROCESS_KEYS.app_id}
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.label}
    }
  }  
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getFriscoTracksForQuarter = (appId, groupId, quarter, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getFRISCOTracksForQuarter(app_id: "${appId}" 
  `
  if (groupId) {
    qry = qry + `, group_id: "${groupId}"`
  }
  qry = qry + `, quarter: "${quarter}") {
    tracking_id
    mapping_id
    track_group
    current_status
    overall_status
    details
    created_time_stamp
    last_updated_time_stamp
  }
}  `

  executeQuery(qry, onSuccess, onFailure)
}

export const getFriscoProcessWithTracksForQuarter = (appId, groupId, quarter, onSuccess, onFailure) => {

  let qry = `query MyQuery {
    getFRISCOProcessWithTracksForQuarter(app_id: "${appId}"
  `
  if (groupId) {
    qry = qry + `, group_id: "${groupId}"`
  }

  qry = qry + `, quarter: "${quarter}") {
    process_id
    process_name
    app_id
    group_id
    group_name
    label
    tracking_id
    mapping_id
    track_group
    current_status
    overall_status
    details
    created_time_stamp
    last_updated_time_stamp
    file_id
    approval_id
    redshift_table_name
    uploaders {
      alias
      type
    }
    approvers {
      alias
      type
      column_index
    }
    custom_attributes {
      attribute
      attribute_type
      sub_type
    }
    aliases {
      alias
      alias_type
      category_id
    }
  }
} `

  executeQuery(qry, onSuccess, onFailure)
}

export const getFriscoGroupById = (groupId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getFRISCOGroupById(group_id: "${groupId}") {
      group_id
      group_name
      app_id
      description
    }
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getFriscoGroupsForAppId = (appId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getFRISCOGroups(app_id: "${appId}") {
      group_id
      group_name
      app_id
      description
    }
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getFRISCOGroupsWithConsolidatedStatusForQuarter = (appId, quarter, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getFRISCOGroupsWithConsolidatedStatusForQuarter(app_id: "${appId}", quarter: "${quarter}") {
      group_id
      group_name
      app_id
      description
      label
      tracking_id
      mapping_id
      track_group
      current_status
      overall_status
      details
      created_time_stamp
      last_updated_time_stamp
      uploaders{
        alias
        type
      }
      approvers{
        alias
        type
      }
    }
  }  
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const deleteProcess = (processId) => {
  let qry = `mutation MyMutation {
    deleteProcessV2(input: {process_id: "${processId}"}) {
      message
    }
  }
  `
  return executeQueryWithoutCallback(qry)
}

export const getFriscoProcessError = (processId) => {
  let qry = `query MyQuery {
    getFriscoProcessError(process_id: "${processId}") {
      unique_id
      process_id
      timestamp
      error
      status
    }
  }
  `
  return executeQueryWithoutCallback(qry)
}

export const getProcessForAppIdPromise = (appId) => {
  let qry = `query MyQuery {
    getProcessesForAppIDV2(app_id: "${appId}") {
      ${PROCESS_KEYS.app_id}
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.label}
    }
  }  
  `
  return callPlusGraphQLDirect(qry)
}

export const getFriscoTransaction = (fileId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getFRISCOTransactions(fileId: "${fileId}") {
      fileId
      processId
      appId
    }
  }`
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const getNotification = (id, id_type, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getNotification(input: {id: "${id}", id_type: "${id_type}"})
  }
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)

}


export const updateAliasToCurrentState = (notification, onSuccess, onFailure) => {
  let input_ext = ' '
  if (notification['sub_id']) {
    input_ext = input_ext + `, sub_id: "${notification['sub_id']}"`
  }
  if (notification['sub_type']) {
    input_ext = input_ext + `, sub_type: "${notification['sub_type']}"`
  }

  let qry = `mutation MyMutation {
  updateAliasToCurrentState(
    input: {id: "${notification['id']}", id_type: "${notification['id_type']}", notification_type: "${notification['notification_type']}" ${input_ext}}
  )
}
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)

}

export const updateAliasToCurrentStateMultiple = (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
  updateAliasToCurrentStateMultiple(
    ${getQueryInput({ "input": data }, [])}
  )
}
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)

}

export const auditSOXFRISCO = (process_id, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    auditSOXFRISCO(input: {process_id: "${process_id}"})
}
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)

}

export const getProcessById = (processId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getProcessByIDV2RDS(process_id: "${processId}") {
      ${PROCESS_KEYS.app_id}
      ${PROCESS_KEYS.group_id}
      ${PROCESS_KEYS.label}
      ${PROCESS_KEYS.description}
      ${PROCESS_KEYS.glue_job_name}
      ${PROCESS_KEYS.step_function_name}
      ${PROCESS_KEYS.environment}
      ${PROCESS_KEYS.action}
      ${PROCESS_KEYS.team}
      ${PROCESS_KEYS.business}
      ${PROCESS_KEYS.dataset_name}
      ${PROCESS_KEYS.created_by}
      ${PROCESS_KEYS.last_updated_by}
      ${PROCESS_KEYS.created_time_stamp}
      ${PROCESS_KEYS.last_updated_time_stamp}
      ${PROCESS_KEYS.status}
      ${PROCESS_KEYS.approval_required}
      ${PROCESS_KEYS.multipart_allowed}
      ${PROCESS_KEYS.next_step}
      ${PROCESS_KEYS.redshift_table_name}
      ${PROCESS_KEYS.sox_approved}
      ${PROCESS_KEYS.sox_evidence}
      ${PROCESS_KEYS.critical_data}
      ${PROCESS_KEYS.custom_attributes}{
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
        
      }
      ${PROCESS_KEYS.approvers}{
        ${PROCESS_KEYS.APPROVER_KEYS.alias}
        ${PROCESS_KEYS.APPROVER_KEYS.type}
        ${PROCESS_KEYS.APPROVER_KEYS.column_index}
      }
      ${PROCESS_KEYS.uploaders}{
        ${PROCESS_KEYS.UPLOADER_KEYS.alias}
        ${PROCESS_KEYS.UPLOADER_KEYS.type}
      }
      ${PROCESS_KEYS.file_types}
      ${PROCESS_KEYS.label}
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.process_name}
      ${PROCESS_KEYS.schema}{
        ${PROCESS_KEYS.SCHEMA_KEYS.column_name}
        ${PROCESS_KEYS.SCHEMA_KEYS.data_type}
        ${PROCESS_KEYS.SCHEMA_KEYS.mandatory}
        ${PROCESS_KEYS.SCHEMA_KEYS.delsert_key}
        ${PROCESS_KEYS.SCHEMA_KEYS.non_empty_column}
        ${PROCESS_KEYS.SCHEMA_KEYS.scale}
        ${PROCESS_KEYS.SCHEMA_KEYS.precision}
        ${PROCESS_KEYS.SCHEMA_KEYS.length}
        ${PROCESS_KEYS.SCHEMA_KEYS.last_updated_time_stamp}
        ${PROCESS_KEYS.SCHEMA_KEYS.column_index}
        ${PROCESS_KEYS.SCHEMA_KEYS.prev_column_name}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_operator}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_value}
        ${PROCESS_KEYS.SCHEMA_KEYS.comparison_type}
      }
      ${PROCESS_KEYS.custom_attributes}{
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
      }
    }
  }
  
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)

}

export const getMappingById = (app_id, processId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getMappingIDV2(app_id: ${app_id}, process_id: ${processId}) {
      ${PROCESS_KEYS.mapping_id}
      ${PROCESS_KEYS.app_id}
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.label}
    }
  }
    
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)

}

export const resetProcessStatus = (process_id, quarter, wb_types, onSuccess, onFailure) => {
  const formattedWbTypes = wb_types.map(type => `"${type}"`).join(',');
  let qry = `mutation MyMutation {
    resetProcessStatus(input: {process_id: "${process_id}", quarter: "${quarter}", wb_types: [${formattedWbTypes}]})
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const resetTemplateStatus = (flex_id, app_id, quarter, wb_types, onSuccess, onFailure) => {
  const formattedWbTypes = wb_types.map(type => `"${type}"`).join(',');
  let qry = `mutation MyMutation {
    resetTemplateStatus(input: {flex_id: "${flex_id}", app_id: "${app_id}", quarter: "${quarter}", wb_types: [${formattedWbTypes}]})
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const updateIntervalFRISCOTrackingStatus = (tracking_id, current_status, overall_status, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
  updateIntervalFRISCOTrackingStatus(tracking_id: "${tracking_id}", current_status: "${current_status}", overall_status:"${overall_status}")
}
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const updateIntervalFlexiCoTrackingStatus = (tracking_id, current_status, overall_status, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
  updateIntervalFlexiCoTrackingStatus(tracking_id: "${tracking_id}", current_status: "${current_status}", overall_status:"${overall_status}")
}
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getQuarter = (quarter) => {
  if (quarter) {
    return `,quarter:"${quarter}"`
  } else {
    return ''
  }
}
export const getTaskId = (taskId) => {
  if (taskId) {
    return `,taskId:"${taskId}"`
  } else {
    return ''
  }
}
export const getRawFile = (rawFilePath) => {
  if (rawFilePath) {
    return `,rawFilePath:"${rawFilePath}"`
  } else {
    return ''
  }
}
export const getRawFileName = (rawFileName) => {
  if (rawFileName) {
    return `,rawFileName:"${rawFileName}"`
  } else {
    return ''
  }
}
export const getSheetName = (sheetName) => {
  if (sheetName && sheetName != '') {
    return `,sheetName:"${sheetName}"`
  } else {
    return ''
  }
}
export const getWBType = (wbType) => {
  if (wbType && wbType != '') {
    return `,wbType:"${wbType}"`
  } else {
    return ''
  }
}


export const createFriscoTransactions = (fileId, appID, pId, status, bucket_name, filePath, fileExt, uploadedTimestamp, uploadedBy, uploadedFileName, quarter = null, taskId = null, rawFilePath = null, rawFileName = null, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    createFRISCOTransactions(input: {fileId: "${fileId}", appId: "${appID}", processId: "${pId}", status: "${status}",bucket_name:"${bucket_name}",
     uploadedTimestamp: "${uploadedTimestamp}", createdTimestamp: "${uploadedTimestamp}", lastUpdatedTimestamp: "${uploadedTimestamp}",uploadedBy: "${uploadedBy}", uploadedFileName: "${uploadedFileName}",
      filePath:"${filePath}", fileExt: "${fileExt}"${getQuarter(quarter)}${getTaskId(taskId)}${getRawFile(rawFilePath)}${getRawFileName(rawFileName)}}) {
      fileId
      appId
      processId
    }
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getFRISCOPreValidationMatchingExcelSheetResults = (fileId, fileExt, pId, onSuccess, onFailure) => {
  let qry = `query Query {
    getFRISCOPreValidationMatchingExcelSheetResults(fileExtension: "${fileExt}", fileId: "${fileId}", processId: "${pId}"){
      fileId
    }
  }    
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const getFRISCOPreValidationResults = (fileId, fileExt, pId, sheetName, onSuccess, onFailure) => {
  let qry = `query Query {
    getFRISCOPreValidationResults(fileId: "${fileId}", processId: "${pId}", fileExtension: "${fileExt}" ${getSheetName(sheetName)})
  }  
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const onMatchResults = (fileId, onResult, onFailure) => {
  let qry = `subscription MySubscription {
    onMatchResults(fileId: "${fileId}") {
      fileId
      payload
    }
  }   
  `
  executeSubscription(qry, onResult, onFailure)
}

export const friscoSubmit = (fileId, appID, pId, status, bucket_name, filePath, fileExt, uploadedTimestamp, uploadedBy, uploadedFileName, sheetName = null, quarter = null, taskId = null, rawFilePath = null, rawFileName = null, wbType = null, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    friscoSubmit(input: {fileId: "${fileId}", appId: "${appID}", processId: "${pId}", status: "${status}",bucket_name:"${bucket_name}",
     uploadedTimestamp: "${uploadedTimestamp}", createdTimestamp: "${uploadedTimestamp}", lastUpdatedTimestamp: "${uploadedTimestamp}",uploadedBy: "${uploadedBy}", uploadedFileName: "${uploadedFileName}",
      filePath:"${filePath}", fileExtension: "${fileExt}"${getQuarter(quarter)}${getTaskId(taskId)}${getRawFile(rawFilePath)}${getRawFileName(rawFileName)}${getSheetName(sheetName)}${getWBType(wbType)} }) 
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getLatestCorpReportingUploadMetadata = (appId, friscoId, quarter, wbStatus, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getLatestCorpReportingUploadMetadata(app_id: "${appId}", frisco_id: "${friscoId}", quarter: "${quarter}"${wbStatus ? `, wb_status: "${wbStatus}"` : ''})
  }`
  executeQuery(qry, onSuccess, onFailure)
}

export const friscoResubmit = (input, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    friscoResubmit(input: {fileId: "${input.fileId}", quarter: "${input.quarter}", wbType: "${input.wbType}", uploadedTimestamp: "${input.uploadedTimestamp}", uploadedBy: "${input.uploadedBy}"})
  }`
  executeQuery(qry, onSuccess, onFailure)
}

export const listFriscoTransactions = (processId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    listFRISCOTransactions(limit: 100,filter: {processId: {eq: "${processId}"}}) {
      items {
        fileId
        processId
        appId
        filePath
        fileExt
        status
        createdTimestamp
        lastUpdatedTimestamp
        uploadedTimestamp
        uploadedBy
        approvedBy
        approvalRequestedTime
        approvalModificationTime
        approvalStatus
        errorMessage
        stepInstanceID
        approvers{
          alias
          type
        }
      }
    }
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getNextTokenQuery = (nextToken) => {
  if (nextToken) {
    return `, after: "${nextToken}"`
  } else {
    return ''
  }

}

export const queryFRISCOTransactionsByAppIdProcessIdIndex = (appId, processId, limit, nextToken, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    queryFRISCOTransactionsByAppIdProcessIdIndex(appId: "${appId}", processId: "${processId}",first: ${limit} ${getNextTokenQuery(nextToken)}) {
      nextToken
      items {
        appId
        processId
        approvalModificationTime
        approvalId
        approvalRequestedTime
        approvalStatus
        approvedBy
        createdTimestamp
        errorMessage
        fileExt
        fileId
        filePath
        lastUpdatedTimestamp
        status
        stepInstanceID
        uploadedBy
        uploadedTimestamp
        jobStartTime
        jobStatusModificationTimestamp
        approvers{
          alias
          type
        }
        rawFileName
        rawFilePath
        uploadedFileName
        workdocsPaths
        workdocsUploadStatus
        workdocsUploadStatusMessage
        supportingDocuments
        stlErrors
      }
    }
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const updateGroups = (app_id, groups, onSuccess, onFailure) => {
  let input = {
    app_id: app_id,
    groups: groups
  }
  let qry = `mutation MyMutation {
    upsertOrDeleteGroupsForApp(input: { ${getQueryInput(input, [])} })
  }`
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const getAliasesByType = (app_id, type, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getAliasesByType(app_id: "${app_id}", type: "${type}") {
      type
      alias
    }
  }`
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const addAliasByType = (app_id, type, aliases, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    addAliasByType(input: {app_id: "${app_id}", type: "${type}", aliases: ${JSON.stringify(aliases)}})
  }
  `
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const getAppTags = (app_id, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getAppTags(id: "${app_id}", id_type: "APP") {
      id
      id_type
      tag
      description
    }
  }`
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const addAppTags = (app_id, tags, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    addAppTags(input: {id: "${app_id}", id_type: "APP", ${getQueryInput(tags, [])}})
  }
`
  // console.log(qry)
  executeQuery(qry, onSuccess, onFailure)
}

export const executeQuery = async (mQry, onSuccess, onFailure, maxRetries = 3, retryDelay = 1000) => {
  let attempts = 0;

  const executeWithRetry = async () => {
    try {
      attempts++;
      const result = await callPlusGraphQLDirect(mQry);
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      if (attempts < maxRetries) {
        const delay = retryDelay * Math.pow(2, attempts - 1);
        await new Promise(resolve => setTimeout(resolve, delay));
        return executeWithRetry();
      }
      if (onFailure) {
        onFailure(error);
      }
    }
  };

  await executeWithRetry();
};

export const executeQueryWithVariables = async (mQry, variables, onSuccess, onFailure) => {
  try {
    const result = await callPlusGraphQLDirect(mQry, variables)
    if (onSuccess) {
      onSuccess(result)
    }
  } catch (error) {
    if (onFailure) {
      onFailure(error)
    }
  }
}

export const executeQueryWithoutCallback = (mQry) => {
  return callPlusGraphQLDirect(mQry)
}

export const executeSubscription = (qry, onResult, onFailure) => {
  const subs = API.graphql(
    graphqlOperation(qry)
  ).subscribe({
    next: (response) => {
      subs.unsubscribe()
      onResult(response)
    },
    error: (error) => {
      subs.unsubscribe()
      onFailure(error)
    },
  });
}

export const getSubLinks = (app_id) => {
  if (app_id == "230") {
    return [{ type: 'side_navigation_bar', label: 'Frisco', url: '/frisco' }]
  }
}

export const getNormalisedColumnName = (colName) => {
  colName = colName.toLowerCase()
  colName = colName.trim()
  let defChar = ''
  colName = colName.replaceAll(/[&\/\\#,+()$~%.'":*?<>{}!@=|-]/g, defChar).replaceAll('^', defChar).replaceAll('[', defChar).replaceAll(']', defChar).replaceAll(';', defChar).replaceAll('`', defChar);
  colName = colName.substring(0, 127)
  colName = colName.replace(/ +/g, ' ');
  colName = colName.trim()
  colName = colName.replaceAll(' ', '_')
  return colName
}


export const constructExcelSheetWithHeadersAndData = (headers, rawData, sheetName = "AllApps") => {


  rawData.forEach((item) => {

    headers.forEach((header) => {
      const val = item[header]
      if (val && typeof val === 'object' && !Array.isArray(val)) {
        let arr = objToArray(val)
        item[header] = arr.join("")
      } else if (Array.isArray(val)) {
        let arr = []
        val.forEach((v, i) => {
          if (typeof (v) === "string" || typeof (v) === "bigint" || typeof (v) === "number" || typeof (v) === "boolean") {
            arr.push(`${v} \r\n`)
          } else if (v && typeof v === 'object' && !Array.isArray(v)) {
            arr.push(...objToArray(v))
          }
        })
        item[header] = arr.join("")
      }
    })


  })


  let ws = XLSX.utils.json_to_sheet(rawData, { header: headers });;
  let wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName);
  XLSX.writeFile(wb, `${sheetName}.xlsx`);


}

const objToArray = (obj) => {
  let arr = []
  for (const [key, value] of Object.entries(obj)) {
    arr.push(`${key} : ${value ? value : "Not Available"} \r\n`)
  }
  return arr
}

export const getSuggestedLogins = (fragment, size, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getSuggestedLogins(fragment: "${fragment}", size: ${size})
  }`
  return executeQueryWithoutCallback(qry)

}

export const updateProcessComment = (processId, commentText, userId = 'system', onSuccess, onFailure) => {
  getProcessById(processId, (result) => {
    const processData = result.data.getProcessByIDV2RDS;
    const processType = 'FRISCO';
    if (!processData) {
      if (onFailure) {
        onFailure(new Error('Process not found'));
      }
      return;
    }

    let customAttributes = processData.custom_attributes || [];
    customAttributes = customAttributes.filter(
      attr => !(attr.attribute_type === 'COMMENT' && attr.sub_type === processType)
    );
    
    customAttributes.push({
      sub_type: processType,
      attribute_type: 'COMMENT',
      attribute: commentText
    });

    const updateInput = {
      process_id: processId,
      process_name: processData.process_name,
      app_id: processData.app_id,
      custom_attributes: customAttributes,
      last_updated_by: userId
    };

    const arr = [PROCESS_KEYS.created_by, PROCESS_KEYS.created_time_stamp, PROCESS_KEYS.last_updated_time_stamp, PROCESS_KEYS.redshift_table_name];
    if (!updateInput[PROCESS_KEYS.status] || updateInput[PROCESS_KEYS.status] == FRISCO_TABLE_STATUS.CREATING_TABLE) {
      arr.push(PROCESS_KEYS.status);
    }
    
    let qry = `mutation MyMutation {
      updateProcessV2(input: {${getQueryInput(updateInput, arr)}}) {
        ${PROCESS_KEYS.process_id}
        ${PROCESS_KEYS.app_id}
        ${PROCESS_KEYS.process_name}
        ${PROCESS_KEYS.custom_attributes}{
          ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
          ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
          ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
        }
      }
    }`;
    
    executeQuery(qry, onSuccess, onFailure);
  }, onFailure);
};

export const updateFlexicoTemplateComment = (flexId, commentText, userId = 'system', onSuccess, onFailure) => {
  getFlexicoTemplateByIdPromise(flexId, (templateData) => {
    if (!templateData) {
      if (onFailure) {
        onFailure(new Error('FlexiCo template not found'));
      }
      return;
    }

    let customAttributes = templateData.custom_attributes || [];
    customAttributes = customAttributes.filter(
      attr => !(attr.attribute_type === 'COMMENT' && attr.sub_type === 'FLEXICO')
    );
    
    customAttributes.push({
      sub_type: 'FLEXICO',
      attribute_type: 'COMMENT',
      attribute: commentText
    });

    const updateInput = {
      flex_id: flexId,
      template_name: templateData.template_name,
      app_id: templateData.app_id,
      custom_attributes: customAttributes,
      last_updated_by: userId
    };

    updateFlexicoTemplate(updateInput, onSuccess, onFailure);
  }, onFailure);
};

export const getProcessByIdPromise = (processId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getProcessByIDV2RDS(process_id: "${processId}") {
      ${PROCESS_KEYS.process_id}
      ${PROCESS_KEYS.process_name}
      ${PROCESS_KEYS.app_id}
      ${PROCESS_KEYS.custom_attributes}{
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
        ${PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
      }
    }
  }`;
  
  executeQuery(qry, 
    (result) => {
      if (onSuccess) {
        onSuccess(result.data.getProcessByIDV2RDS);
      }
    },
    onFailure
  );
};

export const getFlexicoTemplateByIdPromise = (flexId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getFlexicoTemplateRDS(flex_id: "${flexId}") {
      flex_id
      template_name
      app_id
      custom_attributes {
        sub_type
        attribute_type
        attribute
      }
    }
  }`;
  
  executeQuery(qry,
    (result) => {
      if (onSuccess) {
        onSuccess(result.data.getFlexicoTemplateRDS);
      }
    },
    onFailure
  );
};

export const updateFlexicoTemplate = (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    updateFlexicoTemplate(input: {${getQueryInput(data, [])}}) {
      flex_id
      template_name
      app_id
      custom_attributes {
        sub_type
        attribute_type
        attribute
      }
    }
  }`;
  
  executeQuery(qry, onSuccess, onFailure);
};

// LOGICO APIs for AppSync Plus
export const createLogicoProcess = (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    createLogicoProcess(input: {${getQueryInput(data, [])}}
    ) {
      ${LOGICO_PROCESS_KEYS.app_id}
      ${LOGICO_PROCESS_KEYS.process_description}
      ${LOGICO_PROCESS_KEYS.created_by}
      ${LOGICO_PROCESS_KEYS.last_updated_by}
      ${LOGICO_PROCESS_KEYS.created_timestamp}
      ${LOGICO_PROCESS_KEYS.last_updated_timestamp}
      ${LOGICO_PROCESS_KEYS.approval_required}
      ${LOGICO_PROCESS_KEYS.sox_approved}
      ${LOGICO_PROCESS_KEYS.sox_evidence}
      ${LOGICO_PROCESS_KEYS.fast_table}
      ${LOGICO_PROCESS_KEYS.fast_view}
      ${LOGICO_PROCESS_KEYS.critical_data}
      ${LOGICO_PROCESS_KEYS.uploaders}{
        ${LOGICO_PROCESS_KEYS.UPLOADER_KEYS.alias}
        ${LOGICO_PROCESS_KEYS.UPLOADER_KEYS.type}
      }
      ${LOGICO_PROCESS_KEYS.approvers}{
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.alias}
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.type}
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.column_index}
      }
      ${LOGICO_PROCESS_KEYS.custom_attributes}{
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
      }
      ${LOGICO_PROCESS_KEYS.display_label}
      ${LOGICO_PROCESS_KEYS.logico_process_id}
      ${LOGICO_PROCESS_KEYS.process_name}
    }
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const updateLogicoProcess = (data, onSuccess, onFailure) => {
  const arr = [PROCESS_KEYS.created_by, PROCESS_KEYS.created_time_stamp, PROCESS_KEYS.last_updated_time_stamp]

  let qry = `mutation MyMutation {
    updateLogicoProcess(input: {${getQueryInput(data, arr)}}
    ) {
      ${LOGICO_PROCESS_KEYS.app_id}
      ${LOGICO_PROCESS_KEYS.process_description}
      ${LOGICO_PROCESS_KEYS.created_by}
      ${LOGICO_PROCESS_KEYS.last_updated_by}
      ${LOGICO_PROCESS_KEYS.created_timestamp}
      ${LOGICO_PROCESS_KEYS.last_updated_timestamp}
      ${LOGICO_PROCESS_KEYS.approval_required}
      ${LOGICO_PROCESS_KEYS.fast_table}
      ${LOGICO_PROCESS_KEYS.fast_view}
      ${LOGICO_PROCESS_KEYS.sox_approved}
      ${LOGICO_PROCESS_KEYS.sox_evidence}
      ${LOGICO_PROCESS_KEYS.critical_data}
      ${LOGICO_PROCESS_KEYS.uploaders}{
        ${LOGICO_PROCESS_KEYS.UPLOADER_KEYS.alias}
        ${LOGICO_PROCESS_KEYS.UPLOADER_KEYS.type}
      }
      ${LOGICO_PROCESS_KEYS.approvers}{
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.alias}
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.type}
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.column_index}
      }
      ${LOGICO_PROCESS_KEYS.custom_attributes}{
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
      }
      ${LOGICO_PROCESS_KEYS.display_label}
      ${LOGICO_PROCESS_KEYS.logico_process_id}
      ${LOGICO_PROCESS_KEYS.process_name}
    }
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const deleteLogicoProcess = (logicoProcessId, appId, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    deleteLogicoProcess(input: {logico_process_id: "${logicoProcessId}", app_id: "${appId}"})
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getLogicoProcessById = (logicoProcessId, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getLogicoProcessByID(logico_process_id: "${logicoProcessId}") {
      ${LOGICO_PROCESS_KEYS.app_id}
      ${LOGICO_PROCESS_KEYS.process_description}
      ${LOGICO_PROCESS_KEYS.created_by}
      ${LOGICO_PROCESS_KEYS.last_updated_by}
      ${LOGICO_PROCESS_KEYS.created_timestamp}
      ${LOGICO_PROCESS_KEYS.last_updated_timestamp}
      ${LOGICO_PROCESS_KEYS.approval_required}
      ${LOGICO_PROCESS_KEYS.sox_approved}
      ${LOGICO_PROCESS_KEYS.sox_evidence}
      ${LOGICO_PROCESS_KEYS.critical_data}
      ${LOGICO_PROCESS_KEYS.fast_table}
      ${LOGICO_PROCESS_KEYS.fast_view}
      ${LOGICO_PROCESS_KEYS.uploaders}{
        ${LOGICO_PROCESS_KEYS.UPLOADER_KEYS.alias}
        ${LOGICO_PROCESS_KEYS.UPLOADER_KEYS.type}
      }
      ${LOGICO_PROCESS_KEYS.approvers}{
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.alias}
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.type}
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.column_index}
      }
      ${LOGICO_PROCESS_KEYS.custom_attributes}{
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
      }
      ${LOGICO_PROCESS_KEYS.display_label}
      ${LOGICO_PROCESS_KEYS.logico_process_id}
      ${LOGICO_PROCESS_KEYS.process_name}
    }
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getLogicoProcessesForAppId = async (appId) => {
  let qry = `query MyQuery {
    getLogicoProcessesForAppID(app_id: "${appId}") {
      ${LOGICO_PROCESS_KEYS.app_id}
      ${LOGICO_PROCESS_KEYS.process_description}
      ${LOGICO_PROCESS_KEYS.created_by}
      ${LOGICO_PROCESS_KEYS.last_updated_by}
      ${LOGICO_PROCESS_KEYS.created_timestamp}
      ${LOGICO_PROCESS_KEYS.last_updated_timestamp}
      ${LOGICO_PROCESS_KEYS.approval_required}
      ${LOGICO_PROCESS_KEYS.sox_approved}
      ${LOGICO_PROCESS_KEYS.sox_evidence}
      ${LOGICO_PROCESS_KEYS.fast_table}
      ${LOGICO_PROCESS_KEYS.fast_view}
      ${LOGICO_PROCESS_KEYS.critical_data}
      ${LOGICO_PROCESS_KEYS.uploaders}{
        ${LOGICO_PROCESS_KEYS.UPLOADER_KEYS.alias}
        ${LOGICO_PROCESS_KEYS.UPLOADER_KEYS.type}
      }
      ${LOGICO_PROCESS_KEYS.approvers}{
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.alias}
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.type}
        ${LOGICO_PROCESS_KEYS.APPROVER_KEYS.column_index}
      }
      ${LOGICO_PROCESS_KEYS.custom_attributes}{
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute}
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.attribute_type}
        ${LOGICO_PROCESS_KEYS.CUSTOM_ATTRIBUTES_KEYS.sub_type}
      }
      ${LOGICO_PROCESS_KEYS.display_label}
      ${LOGICO_PROCESS_KEYS.logico_process_id}
      ${LOGICO_PROCESS_KEYS.process_name}
    }
  }  
  `
  return callPlusGraphQLDirect(qry)
}

export const listFirstPassHistory = (limit, nextToken, onSuccess, onFailure)=> {
  let qry = `query MyQuery {
  listFirstPassHistory(
    limit: ${limit}
    ${nextToken ? `nextToken: "${nextToken}"` : ''}
  ) {
    items {
      created_at
      current_year
      request_id
      entity_code
      entity_name
      execution_status
      invoke_method
      previous_year
      total_tokens
      response_s3_path
    }
    hasMore
    nextToken
  }
}
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const listFirstPassEntities = (limit, nextToken, onSuccess, onFailure)=> {
  let qry = `query MyQuery {
  listFirstPassEntities(
    limit: ${limit}
    ${nextToken ? `nextToken: "${nextToken}"` : ''}
  ) {
    items {
      entity_code
      language
      entity_name
      last_updated
      pdf_updated_time
      request_id
      region
      country
      accounting_team
    }
    hasMore
    nextToken
  }
}
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getFirstPassHistoryItem = (requestId, onSuccess, onFailure)=> {
  let qry = `query MyQuery {
  getFirstPassHistoryItem(request_id: "${requestId}") {
      created_at
      current_year
      request_id
      entity_code
      entity_name
      execution_status
      invoke_method
      previous_year
      total_tokens
      response_s3_path
  }
}
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const firstPassRunNoteValidator = (requestId, referenceRequestId, entity_code, language, s3_bucket_name, s3_key, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
  firstPassRunNoteValidator(request_id: "${requestId}", reference_request_id: "${referenceRequestId}", entity_code: "${entity_code}", language: "${language}", s3_bucket_name: "${s3_bucket_name}", s3_key: "${s3_key}")
}
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const logicoFileUpload = (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
    fileUploadLogicoProcess(input: {${getQueryInput(data, [])}}) }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const updateLogicoProcessComment = (logicoProcessId, commentText, userId = 'system', onSuccess, onFailure) => {
  getLogicoProcessByIdPromise(logicoProcessId, (processData) => {
    if (!processData) {
      if (onFailure) {
        onFailure(new Error('Logico process not found'));
      }
      return;
    }
    
    let custom_attributes = (processData.custom_attributes || []).filter(
      attr => !(attr.attribute_type === 'COMMENT' && attr.sub_type === 'LOGICO')
    );

    custom_attributes.push({
      sub_type: 'LOGICO',
      attribute_type: 'COMMENT',
      attribute: commentText
    });

    processData.custom_attributes = custom_attributes;
    processData.last_updated_by = userId;
    
    updateLogicoProcess(processData, 
      (result) => {
        if (onSuccess) {
          onSuccess(result.data.updateLogicoProcess);
        }
      }, 
      onFailure
    );
  }, onFailure);
};

export const getLogicoProcessByIdPromise = (logicoProcessId, onSuccess, onFailure) => {
  getLogicoProcessById(logicoProcessId, 
    (result) => {
      if (onSuccess) {
        onSuccess(result.data.getLogicoProcessByID);
      }
    },
    onFailure
  );
};

export const delsertClean = (appId, processId, data, deleteBlankValues, userId, onSuccess, onFailure) => {
  let qry = `mutation MyMutation($data: AWSJSON!) {
    delsertClean(input: {
      processId: "${processId}", 
      appId: "${appId}", 
      data: $data, 
      deleteBlankValues: ${deleteBlankValues},
      userId: "${userId}"
    })
  }`
  let variables = { data: JSON.stringify(data) }
  executeQueryWithVariables(qry, variables, onSuccess, onFailure)
}

export const addRACApp = async (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
      addRACApp(
        input: {
          ${getQueryInput(data)}}) {
            ${TEMPLATE_APP.APP_DESCRIPTION}
            ${TEMPLATE_APP.APP_NAME}
            ${TEMPLATE_APP.APP_ID}
            ${TEMPLATE_APP.TEMPLATE_ID}
            ${TEMPLATE_APP.PROCESS_OWNER}
            ${TEMPLATE_APP.STATUS}
            ${TEMPLATE_APP.CADENCE}
            ${TEMPLATE_APP.ANNUAL_MER_SAVINGS}
            ${TEMPLATE_APP.LEDGER_INFO}
            ${TEMPLATE_APP.LAUNCH_MCM}
            ${TEMPLATE_APP.LAUNCH_QQ_YY}
            ${TEMPLATE_APP.ORGANIZATION}
            ${TEMPLATE_APP.FINANCIAL_RELEVANCE}
            ${TEMPLATE_APP.FINANCIAL_YEAR_IMPACT}
            ${TEMPLATE_APP.VP}
            ${TEMPLATE_APP.GRC_CONTROL_OWNER}
            ${TEMPLATE_APP.CREATE_TIME_STAMP}
            ${TEMPLATE_APP.CREATED_BY}
            ${TEMPLATE_APP.LAST_UPDATED_TIME_STAMP}
            ${TEMPLATE_APP.LAST_UPDATED_BY}
            ${RAC_APP_SPECIFIC_FIELDS.COLLECTION_LINK}
            ${RAC_APP_SPECIFIC_FIELDS.L7_APPROVER}
            ${RAC_APP_SPECIFIC_FIELDS.DEVELOPER_ALIAS}
            ${RAC_APP_SPECIFIC_FIELDS.SUPER_RAC}
            ${RAC_APP_SPECIFIC_FIELDS.RAC_FAST_REVIEWER_ALIAS}
            ${RAC_APP_SPECIFIC_FIELDS.RAC_DATASOURCE}
            ${RAC_APP_SPECIFIC_FIELDS.GRC_SIM_TICKET}
            ${RAC_APP_SPECIFIC_FIELDS.PRIMARY_OR_SECONDARY_LEDGER_IMPACTING}
            ${RAC_APP_SPECIFIC_FIELDS.FINANCIAL_IMPACT_GREATER_THAN_500M_USD}
            ${RAC_APP_SPECIFIC_FIELDS.RESULT_IN_JE_ACC_RECON_FSD_KC}
            ${TEMPLATE_APP.USE_CASE}
            ${TEMPLATE_APP.OUTPUT}{
              ${TEMPLATE_APP_OUTPUT.TYPE}
              ${TEMPLATE_APP_OUTPUT.VALUE}
              ${TEMPLATE_APP_OUTPUT.LABEL}
              ${TEMPLATE_APP_OUTPUT.APP_OUTPUT_PK}
            }
            ${TEMPLATE_APP.PERMISSION}{
              ${TEMPLATE_APP_PERMISSION.LINK}
              ${TEMPLATE_APP_PERMISSION.NAME}
              ${TEMPLATE_APP_PERMISSION.APP_PERMISSION_PK}
            }
            ${TEMPLATE_APP.ACCOUNTING_TEAM} {
              ${TEMPLATE_APP_TEAM.TEAM}
              ${TEMPLATE_APP_TEAM.EMAIL}
            }
      }
    }
    `
  executeQuery(qry, onSuccess, onFailure, 0, 10000)
  

}

export const updateRACApp = (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
      updateRACApp(
        input: {
          ${getQueryInput(data)}}) {
            ${TEMPLATE_APP.APP_DESCRIPTION}
            ${TEMPLATE_APP.APP_NAME}
            ${TEMPLATE_APP.APP_ID}
            ${TEMPLATE_APP.TEMPLATE_ID}
            ${TEMPLATE_APP.PROCESS_OWNER}
            ${TEMPLATE_APP.STATUS}
            ${TEMPLATE_APP.CADENCE}
            ${TEMPLATE_APP.ANNUAL_MER_SAVINGS}
            ${TEMPLATE_APP.LEDGER_INFO}
            ${TEMPLATE_APP.LAUNCH_MCM}
            ${TEMPLATE_APP.LAUNCH_QQ_YY}
            ${TEMPLATE_APP.ORGANIZATION}
            ${TEMPLATE_APP.FINANCIAL_RELEVANCE}
            ${TEMPLATE_APP.FINANCIAL_YEAR_IMPACT}
            ${TEMPLATE_APP.VP}
            ${TEMPLATE_APP.GRC_CONTROL_OWNER}
            ${TEMPLATE_APP.CREATE_TIME_STAMP}
            ${TEMPLATE_APP.CREATED_BY}
            ${TEMPLATE_APP.LAST_UPDATED_TIME_STAMP}
            ${TEMPLATE_APP.LAST_UPDATED_BY}
            ${RAC_APP_SPECIFIC_FIELDS.COLLECTION_LINK}
            ${RAC_APP_SPECIFIC_FIELDS.L7_APPROVER}
            ${RAC_APP_SPECIFIC_FIELDS.RAC_FAST_REVIEWER_ALIAS}
            ${RAC_APP_SPECIFIC_FIELDS.DEVELOPER_ALIAS}
            ${RAC_APP_SPECIFIC_FIELDS.SUPER_RAC}
            ${RAC_APP_SPECIFIC_FIELDS.RAC_DATASOURCE}
            ${RAC_APP_SPECIFIC_FIELDS.GRC_SIM_TICKET}
            ${RAC_APP_SPECIFIC_FIELDS.PRIMARY_OR_SECONDARY_LEDGER_IMPACTING}
            ${RAC_APP_SPECIFIC_FIELDS.FINANCIAL_IMPACT_GREATER_THAN_500M_USD}
            ${RAC_APP_SPECIFIC_FIELDS.RESULT_IN_JE_ACC_RECON_FSD_KC}
            ${TEMPLATE_APP.USE_CASE}
            ${TEMPLATE_APP.OUTPUT}{
              ${TEMPLATE_APP_OUTPUT.TYPE}
              ${TEMPLATE_APP_OUTPUT.VALUE}
              ${TEMPLATE_APP_OUTPUT.LABEL}
              ${TEMPLATE_APP_OUTPUT.APP_OUTPUT_PK}
            }
            ${TEMPLATE_APP.PERMISSION}{
              ${TEMPLATE_APP_PERMISSION.LINK}
              ${TEMPLATE_APP_PERMISSION.NAME}
              ${TEMPLATE_APP_PERMISSION.APP_PERMISSION_PK}
            }
            ${TEMPLATE_APP.ACCOUNTING_TEAM} {
              ${TEMPLATE_APP_TEAM.TEAM}
              ${TEMPLATE_APP_TEAM.EMAIL}
            }
      }
    }
    `
  //console.log(qry)
  executeQuery(qry, onSuccess, onFailure, 0, 10000)

}



export const getRACApp = async (id, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getRACApp(ids: ["${id}"]) {
      ${TEMPLATE_APP.APP_DESCRIPTION}
            ${TEMPLATE_APP.APP_NAME}
            ${TEMPLATE_APP.APP_ID}
            ${TEMPLATE_APP.TEMPLATE_ID}
            ${TEMPLATE_APP.PROCESS_OWNER}
            ${TEMPLATE_APP.STATUS}
            ${TEMPLATE_APP.CADENCE}
            ${TEMPLATE_APP.ANNUAL_MER_SAVINGS}
            ${TEMPLATE_APP.LEDGER_INFO}
            ${TEMPLATE_APP.LAUNCH_MCM}
            ${TEMPLATE_APP.LAUNCH_QQ_YY}
            ${TEMPLATE_APP.ORGANIZATION}
            ${TEMPLATE_APP.FINANCIAL_RELEVANCE}
            ${TEMPLATE_APP.FINANCIAL_YEAR_IMPACT}
            ${TEMPLATE_APP.VP}
            ${TEMPLATE_APP.GRC_CONTROL_OWNER}
            ${TEMPLATE_APP.CREATE_TIME_STAMP}
            ${TEMPLATE_APP.CREATED_BY}
            ${TEMPLATE_APP.LAST_UPDATED_TIME_STAMP}
            ${TEMPLATE_APP.LAST_UPDATED_BY}
            ${RAC_APP_SPECIFIC_FIELDS.COLLECTION_LINK}
            ${RAC_APP_SPECIFIC_FIELDS.L7_APPROVER}
            ${RAC_APP_SPECIFIC_FIELDS.RAC_FAST_REVIEWER_ALIAS}
            ${RAC_APP_SPECIFIC_FIELDS.DEVELOPER_ALIAS}
            ${RAC_APP_SPECIFIC_FIELDS.SUPER_RAC}
            ${RAC_APP_SPECIFIC_FIELDS.RAC_DATASOURCE}
            ${RAC_APP_SPECIFIC_FIELDS.GRC_SIM_TICKET}
            ${RAC_APP_SPECIFIC_FIELDS.PRIMARY_OR_SECONDARY_LEDGER_IMPACTING}
            ${RAC_APP_SPECIFIC_FIELDS.FINANCIAL_IMPACT_GREATER_THAN_500M_USD}
            ${RAC_APP_SPECIFIC_FIELDS.RESULT_IN_JE_ACC_RECON_FSD_KC}
            ${TEMPLATE_APP.USE_CASE}
            ${TEMPLATE_APP.REGION}
            ${TEMPLATE_APP.OUTPUT}{
              ${TEMPLATE_APP_OUTPUT.TYPE}
              ${TEMPLATE_APP_OUTPUT.VALUE}
              ${TEMPLATE_APP_OUTPUT.LABEL}
              ${TEMPLATE_APP_OUTPUT.APP_OUTPUT_PK}
            }
            ${TEMPLATE_APP.PERMISSION}{
              ${TEMPLATE_APP_PERMISSION.LINK}
              ${TEMPLATE_APP_PERMISSION.NAME}
              ${TEMPLATE_APP_PERMISSION.APP_PERMISSION_PK}
            }
            ${TEMPLATE_APP.ACCOUNTING_TEAM} {
              ${TEMPLATE_APP_TEAM.TEAM}
              ${TEMPLATE_APP_TEAM.EMAIL}
            }
      }
    }  
`;
  // console.log(mQry)
 executeQuery(qry, onSuccess, onFailure, 0, 10000)
};


export const createRACAppChangeRequestTicket = async (appId, appName, createdBy, requesterComents, onSuccess, onFailure) => {
  let qry = `
    mutation MyMutation {
  createRACAppChangeRequestTicket(app_id: "${appId}", app_name: "${appName}", created_by: "${createdBy}", requester_coments: "${requesterComents}")
}

    `
    executeQuery(qry, onSuccess, onFailure, 0, 10000)
}


export const incrementViewCount = (appId, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
      incrementViewCount(input: {app_id: "${appId}"})
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const getAppTicketTracking = (appId, onSuccess, onFailure) => {
  let qry = `query GetAppTicketTracking {
      getAppTicketTracking(app_id: "${appId}") {
        items {
          app_id
          table_name
          created_timestamp
          ticket_id
          ticket_url
        }
      }
  }
  `
  executeQuery(qry, onSuccess, onFailure)
}

export const addAIApp = async (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
      addAIApp(
        input: {
          ${getQueryInput(data)}}) {
            ${TEMPLATE_APP.APP_DESCRIPTION}
            ${TEMPLATE_APP.APP_NAME}
            ${TEMPLATE_APP.APP_ID}
            ${TEMPLATE_APP.TEMPLATE_ID}
            ${AI_APP_SPECIFIC_FIELDS.DIRECTOR}
            ${AI_APP_SPECIFIC_FIELDS.OWNING_LDAP}
            ${TEMPLATE_APP.STATUS}
            ${TEMPLATE_APP.ANNUAL_MER_SAVINGS}
            ${TEMPLATE_APP.PDD}
            ${TEMPLATE_APP.ORGANIZATION}
            ${TEMPLATE_APP.VP}
            ${TEMPLATE_APP.GRC_CONTROL_OWNER}
            ${TEMPLATE_APP.CREATE_TIME_STAMP}
            ${TEMPLATE_APP.CREATED_BY}
            ${TEMPLATE_APP.LAST_UPDATED_TIME_STAMP}
            ${TEMPLATE_APP.LAST_UPDATED_BY}
            ${AI_APP_SPECIFIC_FIELDS.USE_CASE_TYPE}
            ${TEMPLATE_APP.REGION}
            ${AI_APP_SPECIFIC_FIELDS.AUTOMATION_TOOL}
            ${AI_APP_SPECIFIC_FIELDS.TAGS}
            ${AI_APP_SPECIFIC_FIELDS.SOLUTION_TYPE}
            ${AI_APP_SPECIFIC_FIELDS.APP_OWNER}
            ${AI_APP_SPECIFIC_FIELDS.PERMISSIONS_LINK}
            ${AI_APP_SPECIFIC_FIELDS.SOX_IMPACT}
            ${AI_APP_SPECIFIC_FIELDS.GRC_LINK}
            ${AI_APP_SPECIFIC_FIELDS.APPLICATION_LINK}
            ${AI_APP_SPECIFIC_FIELDS.OVERVIEW_CONTENT}
            ${AI_APP_SPECIFIC_FIELDS.DEMO_VIDEO_URL}
            ${AI_APP_SPECIFIC_FIELDS.SOP_URL}
            ${AI_APP_SPECIFIC_FIELDS.SUPPORT_CONTACT_NAME}
            ${AI_APP_SPECIFIC_FIELDS.SUPPORT_EMAIL}
            ${TEMPLATE_APP.SOURCE_DATA_TABLES}{
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.DESCRIPTION}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.SCHEMA}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.SOURCE_TABLE_PK}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.TABLE}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.DATABASE}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.UPSTREAM_SOURCE}
            }
            ${TEMPLATE_APP.RATING_AVG}
            ${TEMPLATE_APP.RATING_COUNT}
            ${TEMPLATE_APP.VIEW_COUNT}
            ${TEMPLATE_APP.RUN_COUNT}
            documents
            ${AI_APP_SPECIFIC_FIELDS.INGESTION_METHOD}
      }
    }
    `
  executeQuery(qry, onSuccess, onFailure, 0, 10000)
}

export const updateAIApp = (data, onSuccess, onFailure) => {
  let qry = `mutation MyMutation {
      updateAIApp(
        input: {
          ${getQueryInput(data)}}) {
            ${TEMPLATE_APP.APP_DESCRIPTION}
            ${TEMPLATE_APP.APP_NAME}
            ${TEMPLATE_APP.APP_ID}
            ${TEMPLATE_APP.TEMPLATE_ID}
            ${AI_APP_SPECIFIC_FIELDS.DIRECTOR}
            ${AI_APP_SPECIFIC_FIELDS.OWNING_LDAP}
            ${TEMPLATE_APP.STATUS}
            ${TEMPLATE_APP.ANNUAL_MER_SAVINGS}
            ${TEMPLATE_APP.ORGANIZATION}
            ${TEMPLATE_APP.PDD}
            ${TEMPLATE_APP.VP}
            ${TEMPLATE_APP.GRC_CONTROL_OWNER}
            ${TEMPLATE_APP.CREATE_TIME_STAMP}
            ${TEMPLATE_APP.CREATED_BY}
            ${TEMPLATE_APP.LAST_UPDATED_TIME_STAMP}
            ${TEMPLATE_APP.LAST_UPDATED_BY}
            ${AI_APP_SPECIFIC_FIELDS.USE_CASE_TYPE}
            ${TEMPLATE_APP.REGION}
            ${AI_APP_SPECIFIC_FIELDS.AUTOMATION_TOOL}
            ${AI_APP_SPECIFIC_FIELDS.TAGS}
            ${AI_APP_SPECIFIC_FIELDS.SOLUTION_TYPE}
            ${AI_APP_SPECIFIC_FIELDS.APP_OWNER}
            ${AI_APP_SPECIFIC_FIELDS.PERMISSIONS_LINK}
            ${AI_APP_SPECIFIC_FIELDS.SOX_IMPACT}
            ${AI_APP_SPECIFIC_FIELDS.GRC_LINK}
            ${AI_APP_SPECIFIC_FIELDS.APPLICATION_LINK}
            ${AI_APP_SPECIFIC_FIELDS.OVERVIEW_CONTENT}
            ${AI_APP_SPECIFIC_FIELDS.DEMO_VIDEO_URL}
            ${AI_APP_SPECIFIC_FIELDS.SOP_URL}
            ${AI_APP_SPECIFIC_FIELDS.SUPPORT_CONTACT_NAME}
            ${AI_APP_SPECIFIC_FIELDS.SUPPORT_EMAIL}
            ${TEMPLATE_APP.SOURCE_DATA_TABLES}{
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.DESCRIPTION}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.SCHEMA}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.SOURCE_TABLE_PK}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.TABLE}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.DATABASE}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.UPSTREAM_SOURCE}
            }
            ${TEMPLATE_APP.RATING_AVG}
            ${TEMPLATE_APP.RATING_COUNT}
            ${TEMPLATE_APP.VIEW_COUNT}
            ${TEMPLATE_APP.RUN_COUNT}
            documents
            ${AI_APP_SPECIFIC_FIELDS.INGESTION_METHOD}
      }
    }
    `
  executeQuery(qry, onSuccess, onFailure, 0, 10000)
}

export const getAIApp = async (id, onSuccess, onFailure) => {
  let qry = `query MyQuery {
    getAIApp(ids: ["${id}"]) {
            ${TEMPLATE_APP.APP_DESCRIPTION}
            ${TEMPLATE_APP.APP_NAME}
            ${TEMPLATE_APP.APP_ID}
            ${TEMPLATE_APP.TEMPLATE_ID}
            ${AI_APP_SPECIFIC_FIELDS.DIRECTOR}
            ${AI_APP_SPECIFIC_FIELDS.OWNING_LDAP}
            ${TEMPLATE_APP.STATUS}
            ${TEMPLATE_APP.ANNUAL_MER_SAVINGS}
            ${TEMPLATE_APP.PDD}
            ${TEMPLATE_APP.ORGANIZATION}
            ${TEMPLATE_APP.VP}
            ${TEMPLATE_APP.GRC_CONTROL_OWNER}
            ${TEMPLATE_APP.CREATE_TIME_STAMP}
            ${TEMPLATE_APP.CREATED_BY}
            ${TEMPLATE_APP.LAST_UPDATED_TIME_STAMP}
            ${TEMPLATE_APP.LAST_UPDATED_BY}
            ${AI_APP_SPECIFIC_FIELDS.USE_CASE_TYPE}
            ${TEMPLATE_APP.REGION}
            ${AI_APP_SPECIFIC_FIELDS.AUTOMATION_TOOL}
            ${AI_APP_SPECIFIC_FIELDS.TAGS}
            ${AI_APP_SPECIFIC_FIELDS.SOLUTION_TYPE}
            ${AI_APP_SPECIFIC_FIELDS.APP_OWNER}
            ${AI_APP_SPECIFIC_FIELDS.PERMISSIONS_LINK}
            ${AI_APP_SPECIFIC_FIELDS.SOX_IMPACT}
            ${AI_APP_SPECIFIC_FIELDS.GRC_LINK}
            ${AI_APP_SPECIFIC_FIELDS.APPLICATION_LINK}
            ${AI_APP_SPECIFIC_FIELDS.OVERVIEW_CONTENT}
            ${AI_APP_SPECIFIC_FIELDS.DEMO_VIDEO_URL}
            ${AI_APP_SPECIFIC_FIELDS.SOP_URL}
            ${AI_APP_SPECIFIC_FIELDS.SUPPORT_CONTACT_NAME}
            ${AI_APP_SPECIFIC_FIELDS.SUPPORT_EMAIL}
            ${TEMPLATE_APP.SOURCE_DATA_TABLES}{
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.DESCRIPTION}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.SCHEMA}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.SOURCE_TABLE_PK}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.TABLE}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.DATABASE}
              ${TEMPLATE_APP_SOURCE_DATA_TABLES.UPSTREAM_SOURCE}
            }
            ${TEMPLATE_APP.RATING_AVG}
            ${TEMPLATE_APP.RATING_COUNT}
            ${TEMPLATE_APP.VIEW_COUNT}
            ${TEMPLATE_APP.RUN_COUNT}
            documents
            ${AI_APP_SPECIFIC_FIELDS.INGESTION_METHOD}
      }
    }  
`;
  executeQuery(qry, onSuccess, onFailure, 0, 10000)
}
